<template>
  <Card flat class="nch--blog-categories">
    <h4><i class="mdi mdi-apps"></i>{{ $t('blog.categories.title') }}</h4>
    <nav class="nch--blog-categories">
      <ul>
        <li
          v-for="category in categories"
          :key="category.id"
          :style="`--category-color: ${category.color}`"
        >
          <a
            :href="`/blog/category/${category.translation.slug}`"
            :title="category.translation.name"
          >
            {{ category.translation.name }}
          </a>
        </li>
      </ul>
    </nav>
    <Button
      v-if="pagination.last_page !== pagination.current_page"
      small
      @click.native="nextPage"
    >
      {{ $t('blog.categories.more') }}
    </Button>
  </Card>
</template>

<script>
import Card from '../../common/Card';
import Button from '../../common/Button';

export default {
  name: 'Categories',
  components: {
    Card,
    Button,
  },
  data: () => ({
    loading: false,
    categories: [],
    pagination: {
      page: 1,
      per_page: 5,
    },
  }),
  beforeMount() {
    this.getCategories();
  },
  methods: {
    nextPage() {
      if (this.loading) return;
      this.pagination.page += 1;
      this.getCategories();
    },
    async getCategories() {
      try {
        this.loading = true;
        const { data } = await window.axios
          .get('/api/blog/categories/list', {
            params: this.pagination,
          });
        this.categories = [...this.categories, ...data.data];
        this.pagination = data.meta;
        this.pagination.page = this.pagination.current_page;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.nch--blog-categories{
  flex-direction: column;
  display: flex;
}
@media (max-width: 900px) {
  .nch--blog-categories{
    position: unset;
    top: unset;
  }
}
.nch--blog-categories h4 {
  text-transform: uppercase;
}
.nch--blog-categories ul{
  list-style: none;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  padding: 1rem 0;
}

.nch--blog-categories ul::-webkit-scrollbar {
  width: 5px;
  background: #fff;
}

.nch--blog-categories ul::-webkit-scrollbar-thumb {
  background-color: var(--blog-border);
  border-radius: 3px;
}

.nch--blog-categories li{
  margin: .1rem;
  padding: .3rem;
  border-radius: 3px;
}
.nch--blog-categories li:hover{
  background-color: #e2e2e2;
}
.nch--blog-categories li > a {
  width: 100%;
  display: block;
  color: var(--blog-text);
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}
</style>
